export const WindowKey = {
    Bio: "Bio",
    Abuse: "Abuse",
    Rooms: "Rooms",
    Users: "Users",
    Tip: "Tip",
    Chat: "Chat",
    Private: "Private",
}